import React, {FC} from 'react'
import {useInView} from 'react-cool-inview'

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onVisible: () => void
}

const ViewIntersection: FC<Props> = ({onVisible, children, ...restProps}) => {
  const {observe} = useInView<HTMLDivElement>({
    threshold: 0.1,
    rootMargin: '250px',
    unobserveOnEnter: true,
    onEnter: () => {
      onVisible()
    },
  })

  return (
    <div ref={observe} {...restProps}>
      {children}
    </div>
  )
}

export default ViewIntersection
